import {
  Button,
  Col,
  Modal,
  Row,
  Typography,
  Upload,
  UploadFile,
  UploadProps,
} from "antd";
import "./addLogoModal.scss";
import React, { useEffect, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { updateLogoConfigMapService } from "../../services/configmap.service";
import {
  ConfigMapKey,
  UpdateConfigMapReq,
} from "../../interfaces/configMap.interface";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const AddLogoModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    setShow(props.show);
    if (props.show) {
    }
  }, [props.show]);

  const submit = async () => {
    try {
      setLoading(true);
      const res = await updateLogoConfigMapService(
        { key: ConfigMapKey.organizationLogo } as UpdateConfigMapReq,
        fileList[0]
      );
      setLoading(false);
      toast.success("لوگو با موفقیت ثبت شد");
      setShow(false);
      props.onClose();
      setFileList([]);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const UploadProps: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png";
      if (!isPNG) {
        toast.error(`${file.name} is not a png file`);
      } else {
        setFileList([file]);
        return false;
      }
    },
    fileList,
  };

  return (
    <div className="AddPdfModal">
      <Modal
        destroyOnClose={true}
        title={"ویرایش لوگو"}
        onCancel={() => {
          setShow(false);
          props.onClose();

          setFileList([]);
        }}
        open={show}
        footer={null}
        width={600}
      >
        <div className="AddLogoModalContent">
          <Row justify={"space-between"} align={"middle"}>
            <Col xs={24} className="input-box">
              <Typography.Text type="secondary" className="title">
                فایل (png)
              </Typography.Text>
              <Upload type="drag" className="upload" {...UploadProps}>
                <Button icon={<UploadOutlined />}>Select File</Button>
              </Upload>
            </Col>
          </Row>

          <Row justify={"center"}>
            <Col xs={24}>
              <Button
                onClick={submit}
                loading={loading}
                className="btn"
                type="primary"
                block
              >
                تایید
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
